import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CmsComponent } from './modules/shared/components/cms/cms.component';
import { AboutUsComponent } from './screens/about-us/about-us.component';
import { ContactUsComponent } from './screens/contact-us/contact-us.component';
import { CopyrightPolicyComponent } from './screens/copyright-policy/copyright-policy.component';
import { DisclaimerComponent } from './screens/disclaimer/disclaimer.component';
import { HyperlinkPolicyComponent } from './screens/hyperlink-policy/hyperlink-policy.component';
import { NotFoundComponent } from './screens/not-found/not-found.component';
import { PrivacyPolicyComponent } from './screens/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './screens/terms-conditions/terms-conditions.component';
import { FaqComponent } from './screens/faq/faq.component';
import { AppointmentMapComponent } from './screens/appointment-map/appointment-map.component';
import { environment } from 'src/environments/environment';
import { OurPartnerComponent } from './screens/our-partner/our-partner.component';
let routes: Routes = [
  // { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./screens/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'error',
    loadChildren: () => import('./screens/error-outside-access/error-outside-access.module').then(m => m.ErrorOutsideAccessModule),
  },
  { path: 'about-us', component: AboutUsComponent, data: { title: 'About us' } },
  { path: 'policy', component: CmsComponent, data: { title: 'Policy' } },
  { path: 'schemes', component: CmsComponent, data: { title: 'Schemes' } },
  { path: 'publication', component: CmsComponent, data: { title: 'Publication' } },
  { path: 'rti', component: CmsComponent, data: { title: 'Rti' } },
  { path: 'contact-us', component: ContactUsComponent, data: { title: 'Contact us' } },
  { path: 'notfound', component: NotFoundComponent },
  { path: 'terms-condition', component: TermsConditionsComponent },
  { path: 'copyright-policy', component: CopyrightPolicyComponent },
  { path: 'disclaimer', component: DisclaimerComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'hyperlink-policy', component: HyperlinkPolicyComponent },
  { path: 'faq', component: FaqComponent },
  { path: '7d1ff1b9-4f15-4ba0-8f9d-1624cdfb99ce', component:AppointmentMapComponent},
  { path: 'our-partner', component:OurPartnerComponent},
  { path: '**', redirectTo: '' }

];

if (environment.international) {
  routes = [
    // { path: '', redirectTo: 'index', pathMatch: 'full' },
    {
      path: '',
      loadChildren: () => import('./screens/international/index/index.module').then(m => m.IndexModule),
    },
    {
      path: 'contact-us',
      loadChildren: () => import('./screens/international/contact-us/contact-us.module').then(m => m.ContactUsModule),
    },
    {
      path: 'partner-countries',
      loadChildren: () => import('./screens/international/partner-countries/partner-countries.module').then(m => m.PartnerCountriesModule),
    },
    {
      path: 'error',
      loadChildren: () => import('./screens/error-outside-access/error-outside-access.module').then(m => m.ErrorOutsideAccessModule),
    },
    { path: 'terms-condition',
      loadChildren: () => import('./screens/international/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule),
    },
    { path: 'faq',
      loadChildren: () => import('./screens/international/faq/faq.module').then(m => m.FaqModule),
    },
    { path: 'privacy-policy',
      loadChildren: () => import('./screens/international/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
    },
    { path: '**', redirectTo: '' }
  ];
}



@NgModule({
  imports: [RouterModule.forRoot(routes,{scrollPositionRestoration:'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
